import { FC } from 'react'
import { useSelector } from 'react-redux'
import { getOraclePrices } from '../../redux/modules/app'
import {
  calculateArbAmountKong,
  getCollateralAsNumber,
} from '../../utils/helpers'
import { CssTextField } from '../OpenLoan/OpenLoan'

interface propsState {
  amount: string
}

export const ArbKongEstimate: FC<propsState> = (props) => {
  const oraclePrices = useSelector(getOraclePrices)

  return (
    <CssTextField
      variant="outlined"
      fullWidth={true}
      type={'text'}
      label="Est. BANANA Received"
      id="loan-amount"
      value={calculateArbAmountKong(
        getCollateralAsNumber(props.amount),
        oraclePrices.KONG_USD,
        'KONG'
      )}
    />
  )
}
